"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _shadePickerContext = require("./shadePickerContext");
Object.keys(_shadePickerContext).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _shadePickerContext[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _shadePickerContext[key];
    }
  });
});
